import { apiCall } from '@/lib/api-client';
import type { AdminUser } from '@/types/api';

export interface UpdateProfileInput {
  email?: string;
  fullName?: string;
}

export interface ChangePasswordInput {
  currentPassword: string;
  newPassword: string;
}

export const meApi = {
  get: () => apiCall<AdminUser>('/me/profile'),
  update: (input: UpdateProfileInput) =>
    apiCall<AdminUser>('/me/profile', { method: 'PATCH', body: input }),
  changePassword: (input: ChangePasswordInput) =>
    apiCall<{ ok: true }>('/me/change-password', { method: 'POST', body: input }),
};
